import { Fragment } from "react";
import classNames from "classnames";
import type { ShortcutStep } from "./formatShortcut";
import { ShortcutKey } from "./ShortcutKey";
import styles from "./Shortcut.module.scss";

export type ShortcutSize = "md" | "sm";

/**
 * Draws already-formatted steps: chord keys side by side, steps joined by
 * "then". `Shortcut` feeds it the user's platform; the playground feeds any.
 */
export const ShortcutView = ({
    steps,
    size = "md",
    className,
}: {
    steps: ShortcutStep[];
    size?: ShortcutSize;
    className?: string;
}) => (
    <span
        className={classNames(
            styles.shortcut,
            { [styles.sm]: size === "sm" },
            className,
        )}
    >
        {steps.map((step, stepIndex) => (
            <Fragment key={stepIndex}>
                {stepIndex > 0 && <span className={styles.then}>then</span>}
                <span className={styles.chord}>
                    {step.map((shortcutKey, keyIndex) => (
                        <ShortcutKey key={keyIndex} shortcutKey={shortcutKey} />
                    ))}
                </span>
            </Fragment>
        ))}
    </span>
);
